module.exports = __webpack_public_path__ + "img/arrow-up.8c116b90.svg";